import { render } from "./SDV_Summary.vue?vue&type=template&id=34700612&scoped=true"
import script from "./SDV_Summary.js?vue&type=script&lang=js"
export * from "./SDV_Summary.js?vue&type=script&lang=js"

import "./SDV_Summary.vue?vue&type=style&index=0&id=34700612&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34700612"]])

export default __exports__